// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"476":"b3809a56","1023":"b3809a56","1940":"b3809a56","4296":"b95a82a6"}[chunkId] + ".chunk.css";
};